import cmsApi from '@src/services/cms-api';

const Service = {
  getGameList: () =>
    cmsApi.getArticleList({
      categoryId: 1110,
      pageNum: 1,
      pageSize: 100,
      moreInfo: 1,
      api: '//www.amazingseasun.com/api.php'
    }),
  getRecommendList: () =>
    cmsApi.getArticleList({
      categoryId: 1111,
      pageNum: 1,
      pageSize: 3,
      moreInfo: 1,
      api: '//www.amazingseasun.com/api.php'
    })
};
export default Service;
